import React from 'react';
import {Link} from 'react-router-dom';
import Header from './Header';
import Footer from './Footer';
import company from '../config/company';
import usePageMeta from '../seo/usePageMeta';
import './Pages.css';

const NotFound = () => {
  usePageMeta({
    title: 'Seite nicht gefunden | Cura Care Pflegedienst Eitorf',
    description: 'Die gesuchte Seite gibt es nicht. Hier finden Sie unsere wichtigsten Bereiche.',
    path: '/404',
    noindex: true
  });

  return (
    <div className="page-view">
      <Header />
      <main className="page" id="not-found">
        <div className="page__inner">
          <div className="page__header">
            <p className="kicker">Fehler 404</p>
            <h1>Seite nicht gefunden</h1>
            <p>
              Entschuldigung, die gewünschte Seite ist nicht verfügbar. Vielleicht hilft Ihnen einer
              dieser Bereiche weiter, oder Sie rufen uns einfach an:{' '}
              <a href={`tel:${company.phoneIntl}`}>{company.phone}</a>.
            </p>
          </div>
          <div className="page-section not-found-links">
            <Link className="btn btn--primary" to="/">Zur Startseite</Link>
            <Link className="btn btn--ghost" to="/leistungen">Leistungen</Link>
            <Link className="btn btn--ghost" to="/pflegekosten">Pflegekosten</Link>
            <Link className="btn btn--ghost" to="/faq">Häufige Fragen</Link>
            <Link className="btn btn--ghost" to="/kontakt">Kontakt</Link>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default NotFound;
